import React, { useState } from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { StakingConnectButton } from '@web/features/staking/StakingConnectButton';
import { Button, TabButton } from '@web/ui/components';

import EmptyIconStaked from './StakingGrid/empty-staked.svg';
import { StakingPersonasEmpty } from './StakingGrid/StakingPersonasEmpty';

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing('0250')};
  padding-bottom: ${({ theme }) => theme.spacing('1500')};
  border-bottom-color: ${({ theme }) => theme.color.outlineVariant};
  border-bottom-width: ${({ theme }) => theme.outline['1']};
  border-bottom-style: solid;
`;

type KPersonasTab = 'STAKED' | 'UNSTAKED';

export const StakingPersonasNotConnected = () => {
  const t = useTranslations();

  const [tab, setTab] = useState<KPersonasTab>('STAKED');

  return (
    <>
      <TabsContainer>
        <TabButton
          isActive={tab === 'STAKED'}
          label={t('STAKING_PERSONAS_TAB_STAKED')}
          onClick={() => setTab('STAKED')}
          badgeValue={t('NOT_AVAILABLE')}
        />
        <TabButton
          isActive={tab === 'UNSTAKED'}
          label={t('STAKING_PERSONAS_TAB_UNSTAKED')}
          onClick={() => setTab('UNSTAKED')}
          badgeValue={t('NOT_AVAILABLE')}
        />
      </TabsContainer>
      <StakingPersonasEmpty
        icon={<EmptyIconStaked />}
        title={t('STAKING_PERSONAS_NOT_CONNECTED_TITLE')}
        subtitle={t('STAKING_PERSONAS_NOT_CONNECTED_SUBTITLE')}
        action={
          <StakingConnectButton
            render={({ onClick, isLoading }) => (
              <Button
                label={t('STAKING_PERSONAS_NOT_CONNECTED_ACTION')}
                onClick={onClick}
                disabled={isLoading}
                variant="secondary"
                color="onGreenFixed"
                background="greenFixed"
              />
            )}
          />
        }
      />
    </>
  );
};
